module.exports = __webpack_public_path__ + "img/merlin-head-subscription.6929e486.svg";